import { IEmployeeGroup } from "../../domain/employeeGroups/IEmployeeGroup";
import { IEmployeeGroupRepository } from "../../domain/employeeGroups/IEmployeeGroupRepository";
import { restApiHelper } from "../helpers/RestApiHelper";
import { mapEmployeeGroup } from "./Mappers/mapEmployeeGroups";

export class EmployeeGroupRepository implements IEmployeeGroupRepository {

    async getEmployeeGroups(): Promise<IEmployeeGroup[]> {
        const employeeGroups = await restApiHelper.getData(`api/employeeGroup/all`, {});
        return employeeGroups.map(mapEmployeeGroup);
    }

    async getEmployeeGroup(id: string): Promise<IEmployeeGroup | undefined> {
        return await restApiHelper.getData(`api/employeeGroup/${id}`).catch(x => {
            if (x.xhr.statusCode === 404) {
                return undefined;
            } else {
                throw x;
            }
        });
    }

    async saveEmployeeGroup(employeeGroup: IEmployeeGroup): Promise<any> {
        await restApiHelper.post(`api/employeeGroup`, [employeeGroup]);
    }

    async deleteEmployeeGroup(employeeGroup: IEmployeeGroup): Promise<any> {
        await restApiHelper.delete(`api/employeeGroup/${employeeGroup.id}`);
    }
}
